// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yL-z","twoColumnImage":"zL-z"};